import React from 'react';
import { TdsBlock } from '@scania/tegel-react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/src/styles/hljs';
import ApiDescriptionContainer from '../ApiDescriptionContainer';
import DivTdsBody01 from '../../../../components/atoms/Typography/DivTdsBody01';
import config from '../../../../config';
import LiContainer from '../../../../components/atoms/List/LiContainer';
import LiWithTitle from '../../../../components/atoms/List/LiWithTitle';
import MainHeader from '../../../../components/atoms/Typography/MainHeader';
import SectionLayout from '../../../../components/atoms/Section/SectionLayout';

function DevelopersAccessApiDeleteUserPermissions() {
  return (
    <>
      <div className={'tds-col-xs-12 tds-col-lg-6'}>
        <ApiDescriptionContainer
          description={
            'This endpoint deletes a specific user under a specific customer. The entire user and all permission content for that user will be removed.'
          }
          path={'/v1/auth/customers/'}
          method={'delete'}>
          <SectionLayout header={'Path Parameters'}>
            <LiContainer>
              <LiWithTitle title={'customer_id'}>
                The id of the customer where to lookup the specific user.
              </LiWithTitle>
              <LiWithTitle title={'user_id'}>
                The id of the user to lookup, usually this is the users e-mail address.
              </LiWithTitle>
            </LiContainer>
          </SectionLayout>
          <SectionLayout header={'Required Permissions'}>
            <DivTdsBody01>
              Admin permissions for the specific customer is required in order to get a successful
              response.
            </DivTdsBody01>
          </SectionLayout>
        </ApiDescriptionContainer>
      </div>
      <div className={'tds-col-xs-12 tds-col-lg-6'}>
        <TdsBlock>
          <MainHeader>Example</MainHeader>
          <h3>Request</h3>
          <SyntaxHighlighter language="sh" style={docco} wrapLongLines>
            {"curl '" +
              config.API_GATEWAY_AUTH_URL +
              '/v1/auth/customers/YourReferenceId/users/user.one@yourcompany.eu\' -X DELETE -H "Authorization: Basic $API_KEY"'}
          </SyntaxHighlighter>
          <h3>Response</h3>
          <h4>Status Codes</h4>
          <code>
            204 <span className="code-general-divider">|</span> 400{' '}
            <span className="code-general-divider">|</span> 401
          </code>
          <h4>
            Payload Data <span style={{ fontSize: '0.75rem' }}>(200)</span>
          </h4>
          Not Applicable due to HTTP response 204 (No Content).
        </TdsBlock>
      </div>
    </>
  );
}

export default DevelopersAccessApiDeleteUserPermissions;
